import { WHOLE_BOOK_SPAN_ID } from "@/data/join-chapters";
import type { JourneyMode } from "@/data/schema/compiled";
import { chapterNumber } from "../../book/ChapterId";

export interface PlayerState {
  journey: JourneyMode;
  spanId: string;
  cameraLock: boolean;
  autoZoom: boolean;
}

function runParam(spanId: string): string | null {
  const [first, last] = spanId.split("..");
  const from = first === undefined ? null : chapterNumber(first);
  const to = last === undefined ? null : chapterNumber(last);
  return from === null || to === null ? null : `${from}-${to}`;
}

function address(path: string, params: URLSearchParams): string {
  const search = params.toString();
  return search === "" ? path : `${path}?${search}`;
}

/** The address bar: as short as it can be, leaving out anything at its default. */
export function playerAddress(bookPath: string, state: PlayerState): string {
  const params = new URLSearchParams();
  const number = chapterNumber(state.spanId);
  const run = runParam(state.spanId);
  if (run !== null) {
    params.set("chapters", run);
  }
  if (state.journey === "universe") {
    params.set("view", "story");
  }
  if (!state.cameraLock) {
    params.set("lock", "off");
  }
  if (!state.autoZoom) {
    params.set("zoom", "off");
  }
  return address(`${bookPath}/${number === null ? "play" : `chapter-${number}`}`, params);
}

/**
 * A link to share. It also spells out what a plain address leaves to the visitor's saved
 * settings, so whoever opens it lands on this exact moment.
 */
export function shareAddress(bookPath: string, state: PlayerState, playheadMs: number): string {
  const [path = bookPath, query = ""] = playerAddress(bookPath, state).split("?");
  const params = new URLSearchParams(query);
  if (state.spanId === WHOLE_BOOK_SPAN_ID) {
    params.set("chapters", "all");
  }
  if (state.journey === "book") {
    params.set("view", "book");
  }
  params.set("at", String(Math.round(playheadMs / 100) / 10));
  return address(path, params);
}
